import React from 'react';
import PropTypes from 'prop-types';
import Loading from '../Loading/Loading';
import { ButtonWrapper, LabelWrapper } from './Button.style';

const Button = ({
  text, disabled, handleClick, isLoading,
}) => (
  <ButtonWrapper type="button" onClick={handleClick} disabled={disabled}>
    {isLoading && <Loading pixelWidth={24} />}
    <LabelWrapper hidden={isLoading}>{text}</LabelWrapper>
  </ButtonWrapper>
  );

Button.propTypes = {
  text: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
};

Button.defaultProps = {
  disabled: false,
  isLoading: false,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/Button.js